import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { resetTransaction } from "../../../../../features/TransactionSlice";

import moment from "moment";

const BuyTransactionHistoryDetail = () => {
  const dispatch = useDispatch(); // ไว้อัพเดต state กลาง
  const stateProfile = useSelector((state) => state.profile);
  const stateTransaction = useSelector((state) => state.transaction);

  const resetDataTransaction = () => {
    dispatch(resetTransaction()); // setStateRedux ส่งค่าเก็บเข้า state กลาง
  };

  /* Handle goback */
  const navigate = useNavigate();

  const handleGoBack = () => {
    resetDataTransaction();

    navigate(-1);
  };
  /* End Handle goback */

  /* First event render */
  useEffect(() => {
    // console.log("useEffect !!", stateTransaction, stateProfile);

    if (
      stateTransaction.id === 0 &&
      Object.getOwnPropertyNames(stateTransaction.data).length === 0
    ) {
      navigate("/profile");
    }
  }, []);
  /* End First event render */

  return (
    <>
      <Helmet>
        <title>Health Up</title>
        <meta name="title" content="Health Up" />
        <meta name="description" content="" />
        <meta name="keyword" content="" />
        <meta property="og:title" content="Health Up" />
        <meta property="og:description" content="" />
        <meta property="og:image" content="" />
        <meta property="og:url" content="" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Health Up" />
      </Helmet>

      <div id="pageBuyHistory-details">
        <main>
          <div className="wrapContent">
            <section id="pBuyHistoryDetailsMain">
              <div className="bBuyHistoryDetails">
                <div className="bHead">
                  <div className="bGroup">
                    <div className="bRow">
                      <h1>หมายเลขคำสั่งซื้อ</h1>
                      <h1>{stateTransaction.data.buyNo}</h1>
                    </div>
                  </div>
                </div>
                <div className="bDetails">
                  <div className="bGroup">
                    <div className="bRow">
                      <p>วันและเวลาที่ซื้อ :</p>
                      <p className="textEnd">
                        {stateTransaction.data.buyDate &&
                          moment
                            .utc(stateTransaction.data.buyDate)
                            .format("DD/MM/") +
                            (parseInt(
                              moment
                                .utc(stateTransaction.data.buyDate)
                                .format("YYYY")
                            ) +
                              543) +
                            " " +
                            moment
                              .utc(stateTransaction.data.buyDate)
                              .format("HH:mm") +
                            ` น.`}
                      </p>
                    </div>
                    <div className="bRow text">
                      <p>สาขา :</p>
                      <p className="right textEnd">
                        {stateTransaction.data.branch}
                      </p>
                    </div>
                  </div>
                  <div className="product-list">
                    <div className="tHead">
                      <p>จำนวน</p>
                      <p>ชื่อสินค้า</p>
                      <p>/หน่วย</p>
                      <p>จำนวนเงิน</p>
                    </div>
                    {stateTransaction.data.products &&
                      stateTransaction.data.products.map(
                        ({ name, price, amount }, index) => (
                          <div className="itemList" key={index + 1}>
                            <p>{amount && parseInt(amount).toLocaleString()}</p>
                            <p className="tItem">{name}</p>
                            <p className="total">
                              {price && parseInt(price).toLocaleString()}
                            </p>
                            <p className="total">
                              {price &&
                                `${
                                  parseInt(price) * parseInt(amount)
                                }`.toLocaleString()}
                            </p>
                          </div>
                        )
                      )}
                  </div>

                  <div className="bGroup total">
                    <div className="bRow">
                      <p>จำนวนเงิน</p>
                      <p className="total textEnd">
                        {stateTransaction.data?.totalPrice &&
                          parseInt(
                            stateTransaction.data?.totalPrice || 0
                          ).toLocaleString()}
                      </p>
                    </div>
                    <div className="bRow">
                      <p>ส่วนลดโปรโมชัน</p>
                      <p className="discount textEnd">
                        {stateTransaction.data?.promotionDiscount &&
                          parseInt(
                            stateTransaction.data?.promotionDiscount || 0
                          ).toLocaleString()}
                      </p>
                    </div>
                    <div className="bRow">
                      <p>ส่วนลดคูปอง</p>
                      <p className="discount textEnd">
                        {stateTransaction.data?.couponDiscount &&
                          parseInt(
                            stateTransaction.data?.couponDiscount || 0
                          ).toLocaleString()}
                      </p>
                    </div>
                    <div className="bRow">
                      <p>ส่วนลดสมาชิก</p>
                      <p className="discount textEnd">
                        {stateTransaction.data?.memberDiscount &&
                          parseInt(
                            stateTransaction.data?.memberDiscount || 0
                          ).toLocaleString()}
                      </p>
                    </div>
                    <div className="bRow">
                      <p>ราคารวมสุทธิ</p>
                      <p className="total bold textEnd">
                        {stateTransaction.data?.netPrice &&
                          parseInt(
                            stateTransaction.data?.netPrice || 0
                          ).toLocaleString()}
                      </p>
                    </div>
                  </div>
                  <div className="bGroup point">
                    <div className="bRow">
                      <p>คะแนนที่ได้รับ</p>
                      <p className="textEnd">
                        {(
                          parseInt(stateTransaction.data.pointBill || 0) +
                          parseInt(stateTransaction.data.pointProduct || 0)
                        ).toLocaleString()}
                        {` คะแนน`}
                      </p>
                    </div>
                    <div className="bRow">
                      <p>คะแนนทั้งหมด</p>
                      <p className="textEnd">
                        {stateProfile.dataUser?.currentPoint &&
                          parseInt(
                            stateProfile.dataUser?.currentPoint || 0
                          ).toLocaleString()}
                        {` คะแนน`}
                      </p>
                    </div>
                    <div className="bRow">
                      <p>คะแนนที่กำลังจะหมดอายุ</p>
                      <p className="textEnd">
                        {stateProfile.dataUser?.pointExpiredAt?.point &&
                          parseInt(
                            stateProfile.dataUser?.pointExpiredAt?.point || 0
                          ).toLocaleString()}
                        {` คะแนน `}
                        {stateProfile.dataUser?.pointExpiredAt?.expiredAt
                          ? `(${
                              moment
                                .utc(
                                  stateProfile.dataUser?.pointExpiredAt
                                    ?.expiredAt || ""
                                )
                                .format("DD/MM/") +
                              `${
                                parseInt(
                                  moment
                                    .utc(
                                      stateProfile.dataUser?.pointExpiredAt
                                        ?.expiredAt || ""
                                    )
                                    .format("YYYY")
                                ) + 543
                              }`.slice(-2)
                            })`
                          : ""}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section id="pActionBtn">
              <div className="bBtn">
                <button className="btn outline" onClick={handleGoBack}>
                  ย้อนกลับ
                </button>
              </div>
            </section>
          </div>
        </main>
      </div>
    </>
  );
};

export default BuyTransactionHistoryDetail;
